import { toast } from 'react-toastify';
import { TimeoutToastWithRetry } from '../components/ui/TimeoutToastWithRetry';
import CustomToast from '../components/ui/CustomToast';

export const baseToastStyle = {
  minHeight: '42px',
  padding: '8px 16px',
  fontSize: '13px',
  fontFamily: 'Inter, sans-serif',
  color: 'white',
  width: 'calc(100% - 10px)',
  maxWidth: 'none',
  marginBottom: '10px',
  borderRadius: '6px',
  display: 'flex',
  alignItems: 'center',
  overflowWrap: 'break-word' as const,
  whiteSpace: 'pre-wrap' as const,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
};

export const getToastStyle = (type: 'success' | 'error' | 'warning') => {
  const backgroundColor = {
    success: '#4CAF50',
    error: '#000000',
    warning: '#f16c09',
  }[type];

  return {
    ...baseToastStyle,
    backgroundColor,
  };
};

export const showToast = (
  message: string,
  type: 'success' | 'error' | 'warning' | 'info' = 'success',
  options?: {
    onRetry?: () => void;
    actionButton?: {
      label: string;
      onClick: () => void;
    };
  }
) => {
  const { onRetry, actionButton } = options || {};

  // If it's an error with retry functionality, use the TimeoutToastWithRetry component
  if (type === 'error' && onRetry) {
    const toastId = toast(
      <TimeoutToastWithRetry
        message={message}
        onRetry={onRetry}
        onDismiss={() => toast.dismiss(toastId)}
      />,
      {
        icon: false,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
      }
    );
  } else {
    // Use the new CustomToast component
    toast(
      ({ closeToast }) => (
        <CustomToast
          message={message}
          type={type}
          closeToast={closeToast}
          {...(actionButton ? { actionButton } : {})}
        />
      ),
      {
        icon: false,
        closeButton: false,
        autoClose: 3000,
        closeOnClick: false,
        draggable: false,
        style: {
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
          width: '90vw',
          maxWidth: '90vw',
          margin: '0 auto',
        },
      }
    );
  }
};
